import { AzSearchStore } from "dw_azsearchstore";
import {
  SALES_STEPS,
  TOPICS,
  CLOUD_SOLUTIONS,
  LANGUAGE,
  DOCUMENT_TYPES,
  INDUSTRY,
} from "./constants/facetItems";
import { Configuration } from "./services/configurationService";

const azStoreConfig = (config: Configuration) => {
  let azStore = new AzSearchStore();
  // configuration
  azStore.setConfig({
    index: config.azStoreConfig.index,
    queryKey: config.azStoreConfig.queryKey,
    service: config.azStoreConfig.service,
  });
  azStore.updateSearchParameters({
    count: true,
    queryType: "full",
    top: 15,
    orderby: "CreatedOn desc",
  });
  //set global filters for unpublished articles and those marked as DoNotDisplay in M&S Tool
  azStore.setGlobalFilter("IsPublished", "(IsPublished eq true)");
  azStore.setGlobalFilter("DoNotDisplay", "(DoNotDisplay eq false)");
  //reset input value
  azStore.setInput("");

  // set suggester, project some additional fields into the returned suggestions
  azStore.updateSuggestionsParameters({
    suggesterName: "sg",
    select: "Title,Subtitle,Description,Topic",
  });

  azStore.addCheckboxFacet("SalesSteps", "collection", 20, "value", SALES_STEPS);
  azStore.addCheckboxFacet("Topic", "collection", 20, "value", TOPICS);
  azStore.addCheckboxFacet("CloudSolutions", "collection", 20, "value", CLOUD_SOLUTIONS);
  azStore.addCheckboxFacet("Language", "string", 20, "count", LANGUAGE);
  azStore.addCheckboxFacet("DocumentType", "string", 20, "value", DOCUMENT_TYPES);
  azStore.addCheckboxFacet("Industries", "collection", 20, "value", INDUSTRY);

  azStore.loadInitialFacetValues();

  return { azStore };
};
export { azStoreConfig };
